// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { CriteriaDefinitionBase, CriteriaDefinitionBaseSchema } from 'api/gen/CriteriaDefinitionBase';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { DateCriteriaValues, DateCriteriaValuesSchema } from 'api/gen/DateCriteriaValues';

const requiredPart = t.interface({
  tag: t.literal('DATE'),
  values: DateCriteriaValuesSchema,
});

export const DateCriteriaDefinitionSchema = excess(t.intersection([CriteriaDefinitionBaseSchema.type, requiredPart]));

export interface DateCriteriaDefinition extends t.TypeOf<typeof DateCriteriaDefinitionSchema> {}
